export const {
  VITE_APP_ENV,
  VITE_INITIAL_CDN_PATH,
  VITE_WEBHOOK_BASE_URL,
  VITE_FLAGSMITH_ENV_KEY,
  VITE_WEBHOOK_SPLIT_BASE_URL,
  // ts-prune-ignore-next
  VITE_SENTRY_DSN,
} = import.meta.env;
export const APP_TYPE = 'kitopay';
